import { useContext } from "react";

import { VacancyDetailContext, VacancyDetailContextType } from "../contexts/Vacancy/VacancyDetailContext";

export const useVacancyDetail = (): VacancyDetailContextType => {
  const context = useContext(VacancyDetailContext);
  if (!context) {
    throw new Error("useVacancyDetail must be used within a VacancyDetailProvider");
  }
  return context;
};
